export type IconName = "diagonal" | "right" | "left" | "up" | "down" | "southwest"
  | "drag" | "plus" | "close" | "copy" | "download" | "cube" | "code" | "spark";

const paths: Record<IconName, string> = {
  diagonal: "M6 18 18 6M7 6h11v11",
  right: "M4 12h15m-6-6 6 6-6 6",
  left: "M20 12H5m6-6-6 6 6 6",
  up: "M12 20V5m-6 6 6-6 6 6",
  down: "M12 4v15m-6-6 6 6 6-6",
  southwest: "M18 6 6 18M6 7v11h11",
  drag: "M3 12h18M7 8l-4 4 4 4m10-8 4 4-4 4",
  plus: "M12 5v14M5 12h14",
  close: "m6 6 12 12M6 18 18 6",
  copy: "M8 8h12v12H8ZM4 16V4h12",
  download: "M12 3v12m-5-5 5 5 5-5M4 16v5h16v-5",
  cube: "m12 3 9 5v9l-9 5-9-5V8Zm-9 5 9 5 9-5m-9 5v9M8 5l9 5",
  code: "m8 6-6 6 6 6m8-12 6 6-6 6m-3-14-2 16",
  spark: "M12 2v20M2 12h20M5 5l14 14M5 19 19 5",
};

// SVG paths keep the marks consistent on iOS and iPadOS.
export function Icon({ name, className = "" }: { name: IconName; className?: string }) {
  return (
    <svg className={`icon ${className}`} width="20" height="20" viewBox="0 0 24 24"
      fill="none" aria-hidden="true" focusable="false">
      <path d={paths[name]} stroke="currentColor" strokeWidth="1.6"
        strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export function Arrow({ diagonal = false, className = "" }: { diagonal?: boolean; className?: string }) {
  return <Icon name={diagonal ? "diagonal" : "right"} className={`arrow ${className}`} />;
}

export function Asterisk() {
  return (
    <svg viewBox="0 0 100 100" fill="none" aria-hidden="true" focusable="false">
      <path
        d="M50 8v84M8 50h84M20 20l60 60M20 80l60-60"
        stroke="currentColor"
        strokeWidth="12"
        strokeLinecap="square"
      />
    </svg>
  );
}
